
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/startups/checkout",
      function () {
        return require("private-next-pages/startups/checkout.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/startups/checkout"])
      });
    }
  